module.exports = __webpack_public_path__ + "static/img/SmileAnimation_lemon.db0d605.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_lemon.gif
// module id = Htvp
// module chunks = 0